
import { createApi } from '@reduxjs/toolkit/query/react';

import { customFileFetchBase } from '../../utils/authentication/fetchBaseQuery';
import { transformErrorResponse, transformSuccessResponse } from '../../utils/middleware/responseMiddleware2';

export const fileUploadApi = createApi({

    reducerPath: 'fileUploadApi',
    baseQuery: customFileFetchBase,

    endpoints: (builder) => ({

        //Use this without file. only data needs to post
        postFileData: builder.mutation({
            query: (params) => {
                return {
                    url: params.url,
                    body: params.data,
                    method: 'POST'
                };
            },
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        postFileDataBlob: builder.mutation({
            query: (params) => {
                return {
                    url: params.url,
                    body: params.data,
                    method: 'POST',
                    responseHandler: (response) => response.blob(),
                };
            },
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getFileData: builder.query({
            query: (params) => {
                return {
                    url: params.url,
                    params: params.data,
                    responseHandler: (response) => response.blob(),
                };
            },
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
    }),
});

export const {
    usePostFileDataMutation,
    usePostFileDataBlobMutation,
    useLazyGetFileDataQuery
} = fileUploadApi;
